module.exports = __webpack_public_path__ + "img/EMS_user_manual10.f46e1fbb.png";